import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function fmtError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e.message || "Erreur réseau";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d?.msg || d);
}

export const eur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

export const TERRITOIRES = ["Guadeloupe", "Martinique", "Guyane"];

export const NIVEAU_STYLES = {
  VERT: "bg-emerald-100 text-emerald-900 border-emerald-400 dark:bg-emerald-950 dark:text-emerald-200",
  ORANGE: "bg-amber-100 text-amber-900 border-amber-500 dark:bg-amber-950 dark:text-amber-200",
  ROUGE: "bg-red-100 text-red-900 border-red-500 dark:bg-red-950 dark:text-red-200",
  GRIS: "bg-slate-200 text-slate-700 border-slate-400 dark:bg-slate-800 dark:text-slate-300",
};

export const CONFORMITE_COLORS = {
  VERT: "bg-emerald-500",
  ORANGE: "bg-amber-500",
  ROUGE: "bg-red-500",
  GRIS: "bg-slate-400",
};
